var map = {
	"./background-english.png": 5579,
	"./check_green.png": 8386,
	"./check_red.png": 7414,
	"./common/checkbox/off.svg": 6865,
	"./common/checkbox/on.svg": 9997,
	"./common/icon/close.svg": 4238,
	"./common/icon/correct.svg": 5268,
	"./common/icon/download.svg": 5674,
	"./common/icon/edit.svg": 4806,
	"./common/icon/login.svg": 5665,
	"./common/icon/next.svg": 7209,
	"./common/icon/pdf.svg": 4380,
	"./common/icon/popup-edit/active.svg": 5690,
	"./common/icon/popup-edit/default.svg": 9179,
	"./common/icon/prev.svg": 4489,
	"./common/icon/qr.svg": 4191,
	"./common/icon/remove.svg": 9438,
	"./common/icon/search.svg": 7138,
	"./common/icon/update.svg": 5261,
	"./common/icon/upload.svg": 1897,
	"./common/icon/wrong.svg": 2409,
	"./common/logo.svg": 7761,
	"./correct_icon.png": 3446,
	"./dummy01.png": 2243,
	"./dummy02.png": 5384,
	"./manager/sidemenu/academy.svg": 641,
	"./manager/sidemenu/branch.svg": 3841,
	"./manager/sidemenu/history.svg": 7807,
	"./manager/sidemenu/logout.svg": 5127,
	"./manager/sidemenu/notification.svg": 5604,
	"./manager/sidemenu/scoring.svg": 1760,
	"./manager/sidemenu/study.svg": 5828,
	"./manager/sidemenu/user.svg": 3736,
	"./menu_icon.png": 8097,
	"./menu_logo.png": 1435,
	"./pen/icon_pen_black_off.png": 5553,
	"./pen/icon_pen_black_on.png": 4719,
	"./pen/icon_pen_eraser_off.png": 754,
	"./pen/icon_pen_eraser_on.png": 2462,
	"./pen/icon_pen_highlight_off.png": 6244,
	"./pen/icon_pen_highlight_on.png": 3640,
	"./pen/icon_pen_red_off.png": 593,
	"./pen/icon_pen_red_on.png": 3103,
	"./qr/camera-switch.svg": 3816,
	"./qr/qr.png": 1299,
	"./reload.png": 7639,
	"./tegaki/drill-btn-clear-inactive.png": 2076,
	"./tegaki/drill-btn-eraser-active.png": 2676,
	"./tegaki/drill-btn-eraser-inactive.png": 2357,
	"./tegaki/drill-btn-pen-active.png": 7755,
	"./tegaki/drill-btn-pen-inactive.png": 6162,
	"./tegaki/drill-btn-success-inactive.png": 3682,
	"./wrong_icon.png": 6533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;